import React, { Component } from 'react'
import { Link } from 'react-router-dom'

export class Header extends Component {
  renderSigninLinks() {
    const { authenticatedUser } = this.props
    if (authenticatedUser) {
      return (
        <ul className="nav navbar-nav navbar-right">
          <li>
            <Link to="/dashboard">{ authenticatedUser.nome }</Link>
          </li>
          <li>
            <Link to="/" onClick={this.props.logout}>Sair</Link>
          </li>
        </ul>
      )
    }
    return (
      <ul className="nav navbar-nav navbar-right">
        <li>
          <Link to="/signin">Entrar</Link>
        </li>
        <li>
          <Link to="/signup">Cadastrar</Link>
        </li>
      </ul>
    )
  }

  render() {
    return null
    // return (
    //   <section id="steps-nav" className="main hbox space-between">
    //     <article className="flex vcenter"><span className="banner">automagic<br/>.design</span></article>
    //     <article className="flex4 space-evenly">
    //       <section className="hbox space-evenly steps-nav-section">
    //         <a href="#">
    //           <article className="vbox step-label">
    //             <h2 className="step-num">01</h2>
    //             <div className="">about</div>
    //           </article>
    //         </a>
    //       </section>
    //     </article>
    //   </section>
    // )
 
    // return (
    //    <nav className="navbar navbar-ct-transparent navbar-relative">
    //     <div className="container">
    //       <div className="navbar-header">
    //         <Link className="navbar-brand" to="/">
    //           <div className="logo">
    //             <img src="./avalia-logo-small.png" alt="" />
    //           </div>
    //           <p>Convidai</p>
    //         </Link>
    //       </div>
    //       <ul className="nav navbar-nav navbar-left">
    //         <li>
    //           <Link to="/about">Sobre</Link>
    //         </li>
    //         <li>
    //           <a href="#">Blog</a>
    //         </li>
    //         <li>
    //           <Link to="#">Contato</Link>
    //         </li>
    //       </ul>
    //       { this.renderSigninLinks() }
    //     </div>
    //   </nav>
    // )
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header.js